import { useEffect } from 'react';
// Re-run a loader whenever the tab regains focus.
export const useFocusRefresh = (reload) => {
  useEffect(() => {
    const onVis = () => { if (document.visibilityState === 'visible') reload(); };
    document.addEventListener('visibilitychange', onVis);
    return () => document.removeEventListener('visibilitychange', onVis);
  }, [reload]);
};
